export enum EnumTipoValor {
  Int = 1,
  Decimal = 2,
  Char = 3,
  String = 4,
  DateTime = 5,
  Bool = 6,
  List = 7
}
